import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
/**
 * --------------------------------------------------
 * Suggestion Question Slice
 * --------------------------------------------------
 * This slice manages:
 * - Suggested questions based on selected tags
 * - Tag selection state
 * - Loading & error states
 *
 * NOTE:
 * This slice does NOT use createAsyncThunk.
 * API lifecycle is handled manually using reducers.
 */

/**
 * State structure for suggestion questions
 */
export interface SuggestState {
    suggest: object;
    loading: boolean;
    error: any;
    tagdata: object
}

export const initialState: SuggestState = {
    suggest: [],
    loading: false,
    error: null,
    tagdata: ["math"]
};


export const SuggestionQuestionSlice = createSlice({
    name: "suggest",
    initialState,
    // reducers: {},
    /**
     * reducers
     * --------------------------------------------------
     * These reducers manually control API states.
     *
     * Unlike extraReducers:
     * - Actions are dispatched manually
     * - No createAsyncThunk lifecycle is used
     */
    reducers: {
        /**
         * Updates selected tag for suggestion search
         */
        SearchTags: (state, action) => {
            state.tagdata = [action.payload]
        },

        /**
         * Triggered before suggestion API call
         * Used to show loader
         */
        SuggestionFetch: (state: any, action) => {
            state.loading = true;
        },
        /**
         * Triggered when suggestion API succeeds
         * Stores suggested question data
         */
        SuggestionFulfilled: (state: any, action) => {
            state.loading = false;
            state.suggest = [action.payload];
        },
        /**
         * Triggered when suggestion API fails
         * Stores error and stops loader
         */
        SuggestionRejected: (state: any, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    }

});


export const { SuggestionFetch, SuggestionFulfilled, SuggestionRejected } = SuggestionQuestionSlice.actions;
export default SuggestionQuestionSlice.reducer;